var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'uuid/v4'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/uuid/v4.js' implicitly has an 'any' type.
import uuid from "uuid/v4";
import PersonService from "../../../../Services/Person.service";
import SelectAsyncField from "../../../Form/SelectAsyncField";
export const WAIT_FOR_MESSAGE_SEND_GET_CRITERIA = (formState, { exportNodeId }) => {
    var _a;
    const PERSON_LOADER_DELEGATE_ID = uuid();
    const personLoaderDelegate = {
        id: PERSON_LOADER_DELEGATE_ID,
        type: "PersonLoader",
        criteria: {
            personId: {
                isReference: true,
                workflowNodeReferenceId: exportNodeId,
                propertyName: "studentId",
            },
        },
    };
    return {
        delegates: [personLoaderDelegate],
        criteria: {
            recipientAffiliationId: {
                // @ts-expect-error - TS2339 - Property 'affiliationId' does not exist on type 'PersonLite | { isReference: true; personLoaderId: string; }'.
                value: (_a = formState.recipient) === null || _a === void 0 ? void 0 : _a.affiliationId,
                isReference: false,
            },
            senderAffiliationId: {
                isReference: true,
                workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                propertyName: "affiliationId",
            },
        },
    };
};
export const WAIT_FOR_MESSAGE_SEND_GET_FORM_STATE = (criteria) => __awaiter(void 0, void 0, void 0, function* () {
    const recipient = (yield PersonService.peopleFromAffiliationIds([
        criteria.recipientAffiliationId.value,
    ]))[0];
    return {
        recipient,
    };
});
const WaitForMessageSendWorkflowNodeDefinitionForm = ({ name, }) => {
    return (_jsx(_Fragment, { children: _jsx(SelectAsyncField, { label: "Recipient", valueKey: "affiliationId", name: name ? `${name}.recipient` : "recipient", 
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'. | TS2339 - Property 'fullName' does not exist on type '{ affiliationId: any; }'. | TS2339 - Property 'studentId' does not exist on type '{ affiliationId: any; }'.
            optionRenderer: (option) => `${option.fullName} (${option.studentId})`, placeholder: "Start typing to select a recipient", loadOptions: (search) => __awaiter(void 0, void 0, void 0, function* () {
                return PersonService.searchMessageRecipients(search);
            }) }) }));
};
export default WaitForMessageSendWorkflowNodeDefinitionForm;
